import moment from 'moment';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import { colors } from '@anyroad/theme';
import { roundPrice } from 'lib/pricing_utils';

interface RemainderProps {
  remainderFormatted: string;
  remainderInLocalCurrencyFormatted?: string;
  remainderChargeDaysOffset?: number;
  remainderPaymentDate?: string;
  remainderInCash?: boolean;
  date?: string;
}

const RemainderContainer = styled.div`
  color: ${colors.text.secondary} !important;
  margin: 0 -20px;
  background: ${colors.background.light};
  border-bottom: 0;
  padding: 20px;
`;

export const Remainder = ({
  remainderInCash,
  remainderFormatted,
  remainderInLocalCurrencyFormatted,
  remainderChargeDaysOffset,
  remainderPaymentDate,
  date,
}: RemainderProps) => (
  <RemainderContainer>
    {remainderInCash ? (
      <p>
        <FormattedMessage
          defaultMessage="The remaining balance of {remainderAmount} (in your local currency) should be collected from your guest when they arrive on {bookingDate}."
          values={{
            remainderAmount: roundPrice(remainderFormatted),
            bookingDate: moment(date).format('MMMM Do, YYYY'),
          }}
        />
        {remainderFormatted !== remainderInLocalCurrencyFormatted &&
          remainderInLocalCurrencyFormatted && (
            <FormattedMessage
              defaultMessage="Please pay in the local currency the amount of {remainderAmount}."
              values={{
                remainderAmount: roundPrice(remainderInLocalCurrencyFormatted),
              }}
            />
          )}
      </p>
    ) : (
      <p>
        <FormattedMessage
          defaultMessage="The remaining balance of {remainderAmount} will be charged {dayCount, plural, one {# day} other {# days}} before the experience on {date}."
          values={{
            remainderAmount: roundPrice(remainderFormatted),
            dayCount: remainderChargeDaysOffset,
            date: `${moment(remainderPaymentDate).format('MMMM')} ${moment(remainderPaymentDate).format('Do, YYYY')}`,
          }}
        />
      </p>
    )}
  </RemainderContainer>
);
